import _toConsumableArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import GameListInterface from '../../api/GameListInterface';
import AppBackgroundType from '../../utils/AppBackgroundType';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import Screens from '..';
import RouteParamConstants from '../../utils/routeParamConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
export var PAGE_SIZE = 8;

var Favourites = /*#__PURE__*/function (_Component) {
  function Favourites() {
    var _this2;

    _classCallCheck(this, Favourites);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper2(this, Favourites, [].concat(args));
    _this2.state = {};
    _this2._fetchFavourites = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fetchedFavGames, favouriteGames, _QueryParamsProxy$set;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return GameListInterface.getFavGames();

            case 2:
              fetchedFavGames = _context.sent;
              favouriteGames = transformObjectArrayResponse(fetchedFavGames.FAVOURITE_GAMES);

              _this2._getFavPanelList(favouriteGames);

              _this2.props.setFavouriteGames(favouriteGames);

              if (fetchedFavGames.MESSAGE !== null) {
                QueryParamsProxy.setQueryParams((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_MODAL, Screens.FavouritesExpired), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_MSG, fetchedFavGames.MESSAGE), _QueryParamsProxy$set));
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this2._getFavPanelList = function (rawFavourites) {
      var _this2$props = _this2.props,
          vipGames = _this2$props.vipGames,
          slotGames = _this2$props.slotGames,
          tableGames = _this2$props.tableGames;
      var parsedVipGames = vipGames.gameList[0] ? vipGames.gameList[0].games : [];
      var parsedSlotGames = slotGames.gameList[0] ? slotGames.gameList[0].games : [];
      var parsedTableGames = tableGames.gameList[0] ? tableGames.gameList[0].games : [];
      var allGames = [].concat(_toConsumableArray(parsedVipGames), _toConsumableArray(parsedSlotGames), _toConsumableArray(parsedTableGames));
      var rawFavouriteIds = rawFavourites.map(function (fav) {
        return fav.game_id;
      });
      var panelList = allGames.filter(function (game) {
        return rawFavouriteIds.includes(game.GAME_ID) && !game.IS_HIDDEN;
      });
      var pagedGames = new Array(Math.ceil(panelList.length / PAGE_SIZE)).fill().map(function (currentPage, index) {
        return panelList.slice(index * PAGE_SIZE, (index + 1) * PAGE_SIZE);
      });
      var pageNumber = 0;
      pagedGames.forEach(function (page, index) {
        if (page.find(function (game) {
          return game.UNLOCKED === 'true';
        })) {
          pageNumber = index;
        }
      });

      _this2.setState({
        panelList: panelList,
        pagedGames: pagedGames,
        pageNumber: pageNumber
      });
    };

    _this2._itemClickHandler = function (id) {
      QueryParamsProxy.navigate(_this2.props.navigation, Screens.Game, {
        gid: id
      });
    };

    return _this2;
  }

  _inherits(Favourites, _Component);

  return _createClass(Favourites, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setAppBackground(AppBackgroundType.FAVOURITES);

      this._fetchFavourites();

      Logger.sendEvent(EVENT_TYPES.GAME_ROOM_LOADED, {
        name: 'favorites'
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.favouriteGames.gameList.length !== prevProps.favouriteGames.gameList.length) {
        this._fetchFavourites();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setAppBackground(AppBackgroundType.NORMAL);
    }
  }, {
    key: "render",
    value: function render() {
      var pagedGames = this.state.pagedGames;
      var _this$props = this.props,
          render = _this$props.render,
          lobbyPromotions = _this$props.lobbyPromotions;
      return render({
        itemClick: this._itemClickHandler,
        lobbyPromotions: lobbyPromotions,
        pagedGames: pagedGames,
        pageNumber: 0 // Initial page for the Favourites room should always be the first

      });
    }
  }]);
}(Component);

export { Favourites as default };